import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";


function DocInfo({
  doctor,
  upcomingAppointment,
  isLoading,
  isSuccess,
}) {
  const navigate=useNavigate();
  const navProfileImg = doctor?.imageURL || "https://via.placeholder.com/60";

  if (isLoading) {
    return <div className="p-3">Loading doctor info...</div>;
  }

  if (!isSuccess) {
    return <div className="p-3 text-muted">No data available</div>;
  }

  

  return (
    <div className="row g-4" style={{ alignItems: "stretch" }}>
      {/* Left: Doctor Welcome */}
      <div className="col-md-6" style={{ display: "flex" }}>
        <div
          style={{
            position: "relative",
            background: "#f7fafc",
            borderRadius: 18,
            boxShadow: "0 2px 16px rgba(29, 78, 216, 0.06)",
            padding: "24px 36px 24px 32px",
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            flexGrow: 1,
            cursor: "default",
          }}
        >
          {/* ECG Background */}
          <svg
            viewBox="0 0 240 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              height: "100%",
              width: "50%",
              opacity: 0.1,
              zIndex: 0,
              transformOrigin: "center",
            }}
          >
            <path
              d="M0 80 L12 60 L24 100 L36 40 L48 80 L60 20 L72 80 L84 60 L96 90 L108 30 L120 70 L132 40 L144 90 L156 50 L168 80 L180 30 L192 70 L204 45 L216 85 L228 55 L240 80"
              stroke="#16a34a"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <animate
                attributeName="stroke-dashoffset"
                from="432"
                to="0"
                dur="6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dasharray"
                values="30 402;402 30;30 402"
                dur="6s"
                repeatCount="indefinite"
              />
            </path>
          </svg>

          {/* Content */}
          <img
            src={navProfileImg}
            alt="Profile"
            style={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #E5E7EB",
              marginRight: 24,
              position: "relative",
              zIndex: 1,
              flexShrink: 0,
            }}
          />
          <div style={{ position: "relative", zIndex: 1 }}>
            <div
              style={{
                fontWeight: 700,
                fontSize: "1.25rem",
                color: "#1e293b",
              }}
            >
              Hello, {doctor?.doctorName || "N/A"}
            </div>
            <div style={{ color: "#64748b", marginTop: 3 }}>
              Welcome Back <span style={{ fontSize: "1.1em" }}>✨</span>
            </div>
            <div
              style={{
                marginTop: 14,
                display: "inline-flex",
                alignItems: "center",
                padding: "7px 14px",
                background: "#E5EAF1",
                borderRadius: 16,
                fontSize: "0.95rem",
                color: "#3b82f6",
                userSelect: "none",
              }}
            >
              <i
                className="fa-regular fa-calendar-days"
                style={{ marginRight: 7 }}
              />
              {doctor?.currentDate 
  ? dayjs(doctor.currentDate).format("dddd, DD-MMM-YYYY") 
  : "N/A"}

            </div>
          </div>
        </div>
      </div>

      {/* Right: Appointment */}
      <div className="col-md-6" style={{ display: "flex" }}>
        <div
          style={{
            background: "#fff",
            borderRadius: 18,
            boxShadow: "0 2px 16px rgba(29, 78, 216, 0.06)",
            padding: "24px 32px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flexGrow: 1,
            cursor: "default",
            minHeight: 138,
          }}
        >
          <div
            style={{
              color: "#2563eb",
              fontWeight: 600,
              marginBottom: 18,
              fontSize: "1rem",
            }}
          >
            <i
              className="fa-regular fa-calendar-check"
              style={{ marginRight: 8 }}
            />
            Upcoming Appointment
          </div>

          {upcomingAppointment ? (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      background: "#f1f5f9",
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 700,
                      color: "#2563eb",
                      fontSize: "1.3rem",
                      marginRight: 18,
                      flexShrink: 0,
                    }}
                  >
                    {upcomingAppointment?.patientName?.charAt(0) || "N"}
                  </div>
                  <div>
                    <div
                      style={{
                        fontWeight: 600,
                        color: "#1e293b",
                        fontSize: "1.1rem",
                      }}
                    >
                      {upcomingAppointment?.patientName || "N/A"}
                    </div>
                    <span
                      style={{
                        background: "#f3f4f6",
                        color: "#64748b",
                        borderRadius: 6,
                        fontSize: "0.82rem",
                        fontWeight: 500,
                        padding: "3px 10px",
                        marginTop: 3,
                        display: "inline-block",
                      }}
                    >
                      {upcomingAppointment?.patientIDUniqueID || "N/A"}
                    </span>
                  </div>
                </div>
                <div style={{ marginLeft: "auto", textAlign: "right" }}>
                  <div
                    style={{
                      color: "#4f46e5",
                      fontWeight: 600,
                      background: "#eef2ff",
                      fontSize: "0.92rem",
                      padding: "5px 14px",
                      borderRadius: 8,
                      display: "inline-block",
                      marginBottom: 6,
                    }}
                  >
                    {upcomingAppointment?.appointmentType || "N/A"}
                  </div>
                  <div style={{ fontSize: "0.9rem", color: "#64748b" }}>
                    <span>
                      <i
                        className="fa-regular fa-calendar-days"
                        style={{ marginRight: 6 }}
                      />
                      {upcomingAppointment?.appointmentDate || upcomingAppointment?.appointmentDay
  ? dayjs(upcomingAppointment.appointmentDate || upcomingAppointment.appointmentDay).format("dddd, DD-MMM-YYYY")
  : "N/A"}

                    </span>
                    <span style={{ marginLeft: 20 }}>
                      <i
                        className="fa-regular fa-clock"
                        style={{ marginRight: 6 }}
                      />
                      {upcomingAppointment?.appointmentTime || "N/A"}
                    </span>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: 22 }}>
                <button className="gradient-button" style={{ width: "100%" }}  onClick={() =>
    navigate("/prescriptionform", {
      state: {
        PatientuserUniqueID: upcomingAppointment?.userUniqueID,
        appointmentID: upcomingAppointment?.appointmentID,
        appointmentDate: upcomingAppointment?.appointmentDate?.split("T")[0],
      },
    })
  }>Start Prescription</button>
              </div>
            </>
          ) : (
            <div className="text-muted">No upcoming appointment</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DocInfo;
